module.exports = __webpack_public_path__ + "img/coupon-icon.b2a2956.png";